"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizations = exports.useLocalization = exports.useNamespace = exports.useLanguage = void 0;
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var initialize_1 = require("../lib/initialize");
var namespace_1 = require("../lib/namespace");
function useLanguage() {
    var _a = React.useState(extractUsableLanguage(initialize_1.i18n.language || 'en')), language = _a[0], setLanguage = _a[1];
    React.useEffect(function () {
        function onLanguageChanged(language) {
            setLanguage(extractUsableLanguage(language));
        }
        initialize_1.i18n.on('languageChanged', onLanguageChanged);
        return function () {
            initialize_1.i18n.off('languageChanged', onLanguageChanged);
        };
    }, [setLanguage]);
    return language;
}
exports.useLanguage = useLanguage;
function useNamespace() {
    return React.useContext(namespace_1.NamespaceContext);
}
exports.useNamespace = useNamespace;
function useLocalization(id, defaultValue, variablesOrMode) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var ns = useNamespace();
    // TODO: Figure out if we need to allow changing from dynamic to static and vice versa
    // Currently this will error as we break the rules of hooks
    if (variablesOrMode === 'dynamic') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return React.useCallback(function (overrideVariables) {
            return t(id, __assign({ defaultValue: defaultValue, ns: ns }, overrideVariables));
        }, [ns, t, id, defaultValue]);
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
    return React.useMemo(function () { return t(id, __assign({ defaultValue: defaultValue, ns: ns }, variablesOrMode)); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, id, defaultValue, ns, JSON.stringify(variablesOrMode)]);
}
exports.useLocalization = useLocalization;
function useLocalizations(idsAndDefaultValues, variablesOrMode) {
    var t = (0, react_i18next_1.useTranslation)().t;
    var ns = useNamespace();
    // TODO: Figure out if we need to allow changing from dynamic to static and vice versa
    // Currently this will error as we break the rules of hooks
    if (variablesOrMode === 'dynamic') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return React.useCallback(function (id, variables) {
            return t(id, __assign({ defaultValue: idsAndDefaultValues[id] }, variables));
        }, [t, idsAndDefaultValues]);
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return React.useMemo(function () {
        return Object.keys(idsAndDefaultValues).reduce(function (memo, id) {
            var _a;
            return (__assign(__assign({}, memo), (_a = {}, _a[id] = t(id, __assign({ defaultValue: idsAndDefaultValues[id], ns: ns }, variablesOrMode)), _a)));
        }, {});
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, ns, JSON.stringify(idsAndDefaultValues), JSON.stringify(variablesOrMode)]);
}
exports.useLocalizations = useLocalizations;
/**
 * Converts variant language codes to their pure language variant.
 * Supports language picker components that work with explicit keys
 *
 * Example:
 *  - fr-FR -> fr
 *  - fr-CA -> fr
 */
function extractUsableLanguage(language) {
    var supportedLanguages = initialize_1.i18n.options.supportedLngs;
    if (!Array.isArray(supportedLanguages)) {
        return language;
    }
    // Support explicitly defined language variants e.g en-US
    if (supportedLanguages.includes(language)) {
        return language;
    }
    if (language.includes('-')) {
        var baseLanguage = language.split('-')[0];
        if (supportedLanguages === null || supportedLanguages === void 0 ? void 0 : supportedLanguages.includes(baseLanguage)) {
            return baseLanguage;
        }
    }
    return language;
}
